import { STATE_CODE_TO_NAME } from '@/constants/states';

/**
 * Calculate age from date of birth
 */
export function calculateAge(
  dateOfBirth: Date | null | undefined
): number | null {
  if (!dateOfBirth) {
    return null;
  }

  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // If birthday hasn't occurred yet this year, subtract 1
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

/**
 * Get full state name from state code
 */
export function getStateName(
  stateCode: string | null | undefined
): string | null {
  if (!stateCode) {
    return null;
  }

  return STATE_CODE_TO_NAME[stateCode.toUpperCase()] ?? null;
}
